// extracted by mini-css-extract-plugin
module.exports = {"title":"QualityClasses_title__2uKtU","text":"QualityClasses_text__3RT4h","legendGradient":"QualityClasses_legendGradient__wzR2p"};